/* HAFA – Artikelnummer für Stufenzuschnitte
 *
 * Problem: Breite und Tiefe der Renovierungsstufen wählt der Kunde über Zepto.
 * In der Bestellung stehen dadurch nur die Maße, nicht die HAFA-Artikelnummer –
 * die Zuordnung musste im Lager von Hand passieren (Fehlerquelle bei der Auslieferung).
 *
 * Lösung: Aus der Stamm-SKU des Produkts (z. B. "EN 112001") plus gewählter
 * Breite und Tiefe wird die Artikelnummer gebildet und als Line-Item-Property
 * an den Warenkorb gehängt – sie steht damit in Bestellung, Mail und Packzettel.
 *
 *   Breite  80 → 1 | 100 → 2 | 130 → 3 | 160 → 4 | 180 → 5   (letzte Stelle der Basisnummer)
 *   Tiefe   26,5 → -27 | 32,5 → -33 | 38,5 → -39 | 63,5 → -63
 *
 *   "EN 112001" + 100 + 32,5  ⇒  "EN 112002-33"
 *
 * Gegen Heikes Artikelliste (320 Positionen, 10/2026) vollständig geprüft.
 */
(function () {
  'use strict';

  var BREITE = { '80': '1', '100': '2', '130': '3', '160': '4', '180': '5' };
  var TIEFE  = { '26,5': '27', '32,5': '33', '38,5': '39', '63,5': '63' };

  var daten = document.getElementById('hafa-artnr-daten');
  if (!daten) return;                       // Produkt ohne Zuschnitt-Logik
  var stammSku = (daten.getAttribute('data-stamm-sku') || '').trim();
  var feldName = daten.getAttribute('data-feldname') || 'Artikelnummer';
  if (!/^[A-Z]{2,3} \d{6}$/.test(stammSku)) return;   // unerwartetes SKU-Muster: nichts tun

  var letzteNummer = null;

  function wert(name) {
    var el = document.querySelector('input[name="properties[' + name + ']"]');
    return el ? (el.value || '').trim() : '';
  }

  function bilden() {
    var breite = wert('Stufenbreite in cm');
    var tiefe  = wert('Stufentiefe in cm');
    if (!BREITE[breite] || !TIEFE[tiefe]) return null;   // noch nicht vollständig gewählt
    var teile = stammSku.split(' ');
    return teile[0] + ' ' + teile[1].slice(0, -1) + BREITE[breite] + '-' + TIEFE[tiefe];
  }

  function feld() {
    var vorhanden = document.querySelector('input[name="properties[' + feldName + ']"]');
    if (vorhanden) return vorhanden;
    // in dasselbe Formular hängen, in dem auch die Zepto-Felder liegen
    var muster = document.querySelector('input[name="properties[Stufenbreite in cm]"]');
    var form = muster && muster.form;
    if (!form) return null;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + feldName + ']';
    form.appendChild(input);
    return input;
  }

  function aktualisieren() {
    var nummer = bilden();
    if (nummer === letzteNummer) return;
    var el = feld();
    if (!el) return;
    el.value = nummer || '';
    letzteNummer = nummer;
    var anzeige = document.querySelector('[data-hafa-artnr-anzeige]');
    if (anzeige) {
      anzeige.textContent = nummer || '';
      anzeige.hidden = !nummer;
    }
  }

  // Zepto setzt die Werte per JS – das löst kein input-Event aus.
  // Deshalb nach jedem Klick auf eine Option nachsehen, plus ein ruhiges Netz.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.pplr-drop-item, [data-value]')) {
      setTimeout(aktualisieren, 300);
      setTimeout(aktualisieren, 900);
    }
  });
  setInterval(aktualisieren, 1000);
  aktualisieren();
})();
